import { ReactElement } from 'react'
import ShearCheckSettingsFormFields from '@editor/components/CheckSettingsFormFields/ShearCheckSettingsFormFields'
import MultiEditCheckSettings from '../MultiEditCheckSettings'
import { MultiEditCheckSettingsElement } from '../MultiEditCheckSettings/types'
import {
  buildShearCheckSettingsRow,
  getShearCheckSettings,
  mergeShearCheckSettings,
  normalizeShearCheckSettings,
  shearCheckSettingsColumns,
} from './utils'

interface Props {
  elements: MultiEditCheckSettingsElement[]
}

const MultiEditShearCheck = ({ elements }: Props): ReactElement => (
  <MultiEditCheckSettings
    elements={elements}
    sectionKey="shearCheck"
    settingsLabel="Querkraftabminderungs-Einstellungen"
    getSettings={getShearCheckSettings}
    normalizeSettings={normalizeShearCheckSettings}
    mergeSettings={mergeShearCheckSettings}
    differingSettingsMessage="Elemente haben unterschiedliche Querkraftabminderungs-Einstellungen"
    settingsColumns={shearCheckSettingsColumns}
    buildSettingsRow={buildShearCheckSettingsRow}
    data-cy="shear-check-form"
    changeButtonDataCy="shear-check-change-button"
    fields={<ShearCheckSettingsFormFields memberCheckSettingsSelectedPath="sharedSettings" />}
  />
)

export default MultiEditShearCheck
